import styled, { css } from 'styled-components';

const baseStyle = css`
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    color: ${props => props.variant === 'light' ? '#000 !important' : '#525252'};
    background: #fff;
    border: 2px solid #55585C;
    height: 52px;

    ::placeholder {
        font-size: 0.9rem;
        color: ${props => props.variant === 'light' ? '#000 !important' : '#808080'};
    }

    &:focus, &:focus-visible {
        outline: unset !important;
        border: 2px solid #55585C;
    }

    &.validation-ok{
        border: 2px solid rgba(0, 128, 0, 0.8) !important;
    }
    &.validation-failed{
        border: ${props => props.variant === 'dark' && '2px solid #FF5B6C !important'};
    }

    @media (min-width: 1200px) {
        min-height: 78px;
    }
`;

const CssInput = styled.input`
    ${baseStyle}
    scroll-margin-top: ${(props) => props.labelHeight};
`;

const CssTextarea = styled.textarea`
    ${baseStyle}
    scroll-margin-top: ${(props) => props.labelHeight};
`;

const CssOptionsContainer = styled.div`
    width: 100%;
    max-height: 400px;
    background: white;
    border: 2px solid #55585C;
    z-index: 1000;
    border-left: 2px solid #55585C;
    border-right: 2px solid #55585C;
    border-bottom: 2px solid #55585C;

    ::placeholder {
        color: #C4D0CD !important;
    }

    .option{
        margin-bottom: 0;
        transition: color .3s ease, background-color .3s ease;
        cursor: pointer;
        color: #525252;
        border-bottom: 0.5px solid #C4D0CD;
        padding: 10px 0px;
        &:hover, &:focus{
            background-color: #ededed;
            color: #55585C;
        }
    }

    .selected-container{
        border-bottom: 1px solid rgba(49, 49, 48, 0.1);
        cursor: pointer;
        .selected{
            transition: color .3s ease, background-color .3s ease;
            font-size: 16px;
            background-color: #f5f5f5;
            border-color: #55585C;
            border-radius: 24px;
            &:hover {
                background-color: #B72D55;
                color: white !important;
            }
        }
    }
`;

const CssToggle = styled.label`
    top: 7px;
    width: 45px;
    height: 25px;
    cursor: pointer;
    position: relative;

    input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        &:checked+.toggle-slider {
            background-color: #2faf9a;

            .toggle-knob {
                left: calc(100% - 19px - 3px);
            }
        }
    }

    .toggle-slider {
        background-color: #ccc;
        position: absolute;
        border-radius: 100px;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-transition: left 300ms ease, background-color 300ms ease;
        transition: left 300ms ease, background-color 300ms ease;

        .toggle-knob {
            position: absolute;
            -webkit-transition: left 300ms ease, background-color 300ms ease;
            transition: left 300ms ease, background-color 300ms ease;
            width: calc(25px - 6px);
            height: calc(25px - 6px);
            border-radius: 50%;
            left: 3px;
            top: 3px;
            background-color: #fff;
        }
    }
`;

const CssCheckbox = styled.div` 
    input[type="checkbox"] {
        display:none;
    }
    div.checkmark {
        width: 20px;
        height: 20px;
        
        cursor: pointer;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        margin-right: 4px;
        background-color: transparent;
        border: 1px solid #999;
    
        &.light {
            background-color: white;
            border: 1px solid #333;
        }

        &.checked {
            background-color: #525252;
            border: none;
            svg {
                display: flex;
                color: white;
                opacity: 1;
            }
        }
        svg {
            display: flex;
            opacity: 0;
        }
    }
`;

const CssRadio = styled.div`
    input[type="radio"] {
    display: none;
    }
    div.radio {
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    cursor: pointer;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
        &.checked::after {
            content: " ";
            width: 10px;
            height: 10px;
            border-radius: 10px;
            background-color: #525252;
            padding: 2px;
        }
    }
`;

const CssControlEnd = styled.div`
    right:1px;
    top:1px;
    height: calc(100% - 2px);
    padding-right: 5px;
`;

const CssCheckIcon = styled.span`
    transition: left 300ms ease, background-color 300ms ease;
    transform: scale(0);
    width: 0px;
    height: 24px;
    background-size: contain;
   
    &.validation-ok, &.validation-failed, &.vb-caret, &.vb-cross{
        cursor: pointer;
        width: 24px;
        transform: scale(1);
        background-repeat: no-repeat;
    }
    &.validation-ok{
        background-image: url('https://hosted-static.s3.eu-north-1.amazonaws.com/img/check-circled.svg')!important;
    }
    &.validation-failed{
        background-image :url('https://hosted-static.s3.eu-north-1.amazonaws.com/img/cross-circled.svg')!important;
    }
    &.vb-caret{
        transition: 300ms ease;
        background-image: url('https://hosted-static.s3.eu-north-1.amazonaws.com/img/dropdown-arrow.svg')!important;
        &.on-focus{
            transform: rotate(-180deg);
        }
    }
    &.vb-cross{
        background-image: url('https://hosted-static.s3.eu-north-1.amazonaws.com/img/close.svg')!important;
    }
`;

export { CssInput, CssToggle, CssCheckbox, CssRadio, CssTextarea, CssCheckIcon, CssControlEnd, CssOptionsContainer }
